export const searchAdminRadiusUserGroup = (search) => ({
  method: 'GET',
  path: `admin_rad_usergroup?${search}`,
});

export const createAdminRadiusUserGroup = (body) => ({
  method: 'POST',
  path: 'admin_rad_usergroup',
  body: JSON.stringify(body),
});

export const deleteAdminRadiusUserGroup = (body) => ({
  method: 'DELETE',
  path: 'admin_rad_usergroup',
  body: JSON.stringify(body),
});

export const getAdminRadCheckByUsername = (username) => ({
  method: 'GET',
  path: `admin_radcheck/username/${username}`,
});

export const createAdminRadCheck = (body) => ({
  method: 'POST',
  path: 'admin_radcheck',
  body: JSON.stringify(body),
});

export const updateAdminRadCheck = (body, id) => ({
  method: 'PUT',
  path: `admin_radcheck/${id}`,
  body: JSON.stringify(body),
});

const adminNasPath = 'admin_nas';

export const createAdminNas = (body) => ({
  method: 'POST',
  path: `${adminNasPath}`,
  body: JSON.stringify(body),
});

export const searchAdminNas = (search) => ({
  method: 'GET',
  path: `${adminNasPath}${search}`,
});

export const updateAdminNas = (body, id) => ({
  method: 'PUT',
  path: `${adminNasPath}/${id}`,
  body: JSON.stringify(body),
});

export const deleteAdminNas = (id) => ({
  method: 'DELETE',
  path: `${adminNasPath}/${id}`,
});

export const getAdminNas = (id) => ({
  method: 'GET',
  path: `${adminNasPath}/${id}`,
});
